import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Flex } from '@chakra-ui/react'

import { LeidButton, LeidButtonWhiteOutlined } from 'components/ui/Buttons/Button'
import { Loader } from 'components/ui/Loader'
import apiClient from 'helpers/clients/apiClient'
import { displaySnackbar } from 'store/partials/snackbar/snackbarSlice'

import { OpenDoorStepData } from '../models'

type Props = {
  data: OpenDoorStepData
  onStepSuccess: () => void
}

const OpenDoorStep = (props: Props): JSX.Element => {
  const { data, onStepSuccess } = props

  const [triggerInProgress, setTriggerInProgress] = useState(false)

  const { t } = useTranslation('common')
  const dispatch = useDispatch()

  const triggerOutput = async (): Promise<boolean> => {
    const triggeredResponse = await apiClient.triggerSubLocationOutput({
      locationId: data.locationId ?? 0,
      sublocationId: data.sublocationId,
      ioId: data.deviceId,
      userId: 0,
      orderId: data.orderId,
      customerId: data.customerId,
    })

    if (!triggeredResponse.success) {
      dispatch(displaySnackbar({ message: t('error'), isError: true }))
      console.error('Failed to trigger output')
      return false
    }

    return true
  }

  const handleAlreadyInsideButton = () => {
    onStepSuccess()
  }

  const handleOpenDoorsButton = async () => {
    setTriggerInProgress(true)
    const triggerResult = await triggerOutput()
    setTriggerInProgress(false)

    if (triggerResult) {
      onStepSuccess()
    }
  }

  return (
    <>
      <LeidButton onClick={handleOpenDoorsButton}>
        <Flex flexDirection="row" justifyContent="safe center" alignItems="center" width="100%" gridGap="12px">
          {triggerInProgress && <Loader size="md" width="auto" margin="0" />}
          {t(`openTheDoor`, { name: data.doorName })}
        </Flex>
      </LeidButton>
      <LeidButtonWhiteOutlined onClick={handleAlreadyInsideButton}>{t('alreadyInside')}</LeidButtonWhiteOutlined>
    </>
  )
}

export default OpenDoorStep
